/**
 * DetectionDurationSelect
 *
 * MUI TextField select for the HazardAI Total Detections panel's rolling
 * comparison window. Offers Day / Week (7 Days) / Month (30 Days) /
 * Year (365 Days) / Custom, each resolved client-side via
 * resolveDurationPreset() from utils/dateRange.ts.
 *
 * Intentionally separate from DateRangePresetSelect — the preset union types
 * differ and keeping it standalone preserves a clean boundary for the planned
 * dashboard-date-range integration.
 */

import {MenuItem, TextField} from '@mui/material';

import {
  DETECTION_DURATION_PRESETS,
  DetectionDurationPreset,
} from '../../utils/dateRange';

interface DetectionDurationSelectProps {
  value: DetectionDurationPreset | null;
  onChange: (value: DetectionDurationPreset) => void;
  label?: string;
  fullWidth?: boolean;
  size?: 'small' | 'medium';
  disabled?: boolean;
}

export const DetectionDurationSelect: React.FC<DetectionDurationSelectProps> = ({
  value,
  onChange,
  label = 'Period',
  fullWidth = true,
  size,
  disabled,
}) => {
  return (
    <TextField
      select
      fullWidth={fullWidth}
      label={label}
      value={value ?? ''}
      size={size}
      disabled={disabled}
      onChange={(e) => onChange(e.target.value as DetectionDurationPreset)}
    >
      {DETECTION_DURATION_PRESETS.map((preset) => (
        <MenuItem key={preset.value} value={preset.value}>
          {preset.label}
        </MenuItem>
      ))}
    </TextField>
  );
};
